import React, { useEffect, useRef, useState } from "react";
import { Button, Typography, CircularProgress } from "@mui/material";
import {
  onAuthStateChanged,
  signInWithPopup,
  GoogleAuthProvider,
  setPersistence,
  browserLocalPersistence,
} from "firebase/auth";
import { checkAndStoreUserData } from "../../utils/utilFunctions";
import CloudQueueRoundedIcon from "@mui/icons-material/CloudQueueRounded";
import { auth } from "../../Backend/Firebase.js";

const GoogleSignIn = ({ onSignIn }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true); // Add loading state
  const manualSignInRef = useRef(false);

  useEffect(() => {
    // Set local persistence
    setPersistence(auth, browserLocalPersistence)
      .then(() => console.log("Persistence mode set to local."))
      .catch((error) => console.error("Failed to set persistence:", error));

    // Monitor auth state
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser || null); // Update user state
      setLoading(false); // Authentication check is done
      if (currentUser) {
        if (!manualSignInRef.current) {
          onSignIn(currentUser, { showWelcome: false }); // Notify parent component
        }
      }
    });

    return () => unsubscribe(); // Cleanup subscription
  }, [onSignIn]);

  // Handle Google Sign-In
  const handleSignIn = async () => {
    const provider = new GoogleAuthProvider();
    provider.setCustomParameters({ prompt: "select_account" });

    try {
      const result = await signInWithPopup(auth, provider);
      const loggedInUser = result.user;
      manualSignInRef.current = true;
      checkAndStoreUserData(loggedInUser).catch((error) =>
        console.error("Could not update the account profile:", error)
      );

      onSignIn(loggedInUser, { showWelcome: true }); // Notify parent component
    } catch (error) {
      console.error("Error signing in:", error);
      alert("Failed to sign in. Please try again.");
    }
  };

  return (
    <div className="my-presets-signin">
      {loading ? (
        <div className="my-presets-status">
          <CircularProgress size={22} />
          <span>Checking your account…</span>
        </div>
      ) : !user ? (
        <>
          <span className="my-presets-signin-icon">
            <CloudQueueRoundedIcon />
          </span>
          <h2>Keep your presets with you</h2>
          <p>Sign in to create routines and sync them across your devices.</p>
          <Button onClick={handleSignIn} variant="contained">
            Continue with Google
          </Button>
          <small className="my-presets-signin-note">
            Google sign-in is the only login option for now.
          </small>
        </>
      ) : (
        <Typography variant="body2">Opening your presets…</Typography>
      )}
    </div>
  );
};

export default GoogleSignIn;
